export default "__VITE_ASSET__Bm2av2AP__"